import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from '@aws-amplify/auth';
import { NbCardModule } from '@nebular/theme';
import { Store } from '@ngxs/store';
import { SpinnerComponent } from 'src/app/shared/ui/spinner/spinner.component';
import { ENVIRONMENT } from 'src/environments/environment';
import { SetIsLogedIn, SetUserGroups, SetUsername } from '../redux';

@Component({
  selector: 'app-okta-login',
  templateUrl: './okta-login.component.html',
  styleUrls: ['./okta-login.component.css'],
  imports: [SpinnerComponent, NbCardModule]
})
export class OktaLoginComponent implements OnInit {
  public environment = ENVIRONMENT.name;

  constructor(
    private store: Store,
    private router: Router
  ) {}

  public ngOnInit() {
    Auth.currentSession()
      .then((session) => {
        const payload = session.getIdToken().payload;
        this.store.dispatch([
          new SetUsername(payload.email),
          new SetUserGroups(JSON.parse(payload['custom:groups'])),
          new SetIsLogedIn(true)
        ]);
        this.router.navigateByUrl('/quick-start');
      })
      .catch(() => {
        Auth.federatedSignIn({ customProvider: 'OKTA' });
      });
  }
}
